if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.connectedButtons = document.querySelectorAll(
          `[data-master="${this.submitButton.id}"]`,
        );
        this.triggerSubmit = () => this.submitButton.click();

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
          this.connectedButtons.forEach(button =>
            button.setAttribute('aria-haspopup', 'dialog'),
          );
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.connectedButtons.forEach(button =>
          button.addEventListener('click', this.triggerSubmit),
        );
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.connectedButtons.forEach(button =>
          button.removeEventListener('click', this.triggerSubmit),
        );
      }

      disableButton(button) {
        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
        button.querySelector('.loading__spinner').classList.remove('hidden');
      }

      enableButton(button) {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        button.querySelector('.loading__spinner').classList.add('hidden');
      }

      setButtonErrorState(button) {
        const soldOutMessage = button.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        button.setAttribute('aria-disabled', true);
        button.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
      }

      pushATC(formData) {
        const subscriptionOptions = document.querySelector(
          'subscription-options',
        );
        if (!subscriptionOptions) return;

        const event = 'custom_add_to_cart';
        const purchaseType = subscriptionOptions.getAttribute('purchase-type');
        const atcType = 'pdp';
        const item_id = subscriptionOptions.getAttribute('product-id');
        const item_name = subscriptionOptions.getAttribute('product-name');
        const item_variant = formData.get('id');
        const price = subscriptionOptions.getAttribute('price');
        const item_brand = 'FullWell';
        const quantity = formData.get('quantity');

        const dataLayer = (window.dataLayer = window.dataLayer || []);
        dataLayer.push({
          event,
          purchaseType,
          atcType,
          ecommerce: {
            items: [
              {
                item_id,
                item_name,
                item_variant,
                price,
                item_brand,
                quantity,
              },
            ],
          },
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.disableButton(this.submitButton);
        this.connectedButtons.forEach(button => this.disableButton(button));

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.pushATC(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              const errorMsg =
                response.errors || response.description || response.message;

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: errorMsg,
                message: response.message,
              });
              this.handleErrorMessage(errorMsg);

              this.setButtonErrorState(this.submitButton);
              this.connectedButtons.forEach(button =>
                this.setButtonErrorState(button),
              );
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.enableButton(this.submitButton);
            this.connectedButtons.forEach(button => this.enableButton(button));
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
